(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["consent-banner-offset"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.documentElement;
    var resizeObserver = null;
    var watched = null;

    function publish() {
      var banner = document.getElementById('shopify-pc__banner');
      var visible = banner && banner.offsetHeight > 0 && getComputedStyle(banner).display !== 'none';
      root.style.setProperty('--rc-consent-banner-height', visible ? banner.offsetHeight + 'px' : '0px');
      root.toggleAttribute('data-consent-banner', !!visible);
    }

    function watch() {
      var banner = document.getElementById('shopify-pc__banner');
      if (banner !== watched) {
        if (resizeObserver) resizeObserver.disconnect();
        watched = banner;
        if (banner && typeof ResizeObserver === 'function') {
          resizeObserver = new ResizeObserver(publish);
          resizeObserver.observe(banner);
        }
      }
      publish();
    }

    // The banner is added and removed by Shopify's own script, so watch the body for it.
    new MutationObserver(watch).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', publish);
    watch();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["maintenance-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    // No banner in the DOM means maintenance_on was false for this render —
    // Liquid can't gate this script block itself (see the explanatory
    // comment above the stylesheet/javascript blocks in this file), so the
    // script gates itself on the one thing that DOES reflect that: whether
    // its own banner div actually rendered.
    if (!document.querySelector('[data-maintenance-banner]')) return;

    var LABEL = 'Temporarily unavailable. Store under maintenance';

    // Union of every known "commit to a purchase" control in the theme:
    // the shared add-to-cart button (snippets/add-to-cart-button.liquid,
    // rendered by buy-buttons, quick-add, and the PDP form alike), any
    // other submit button inside a form that posts to /cart/add (catches
    // less common entry points, e.g. the quick-order-list bulk table,
    // without needing a bespoke selector per section), and the cart's
    // checkout button (snippets/cart-summary.liquid).
    var SELECTOR = [
      'button[name="add"]',
      'form[action*="/cart/add"] button[type="submit"]',
      'button[name="checkout"]',
      '#checkout',
    ].join(', ');

    function disable(el) {
      if (!el || el.dataset.maintenanceDisabled === 'true') return;
      el.dataset.maintenanceDisabled = 'true';
      el.disabled = true;
      el.setAttribute('aria-disabled', 'true');
      el.classList.add('maintenance-disabled');
      el.title = LABEL;
    }

    function sweep(root) {
      if (root.nodeType !== 1 && root.nodeType !== 9) return;
      if (root.matches && root.matches(SELECTOR)) disable(root);
      if (root.querySelectorAll) {
        root.querySelectorAll(SELECTOR).forEach(disable);
      }
    }

    sweep(document);

    // The theme re-renders parts of the page client-side (cart drawer
    // contents, quick-add modal, section morphing after a fetch) without a
    // full navigation, which would otherwise let a freshly-inserted
    // add-to-cart/checkout button slip past the initial sweep above.
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          sweep(added[j]);
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price-trend-chart"] && !Shopify.designMode) return;
  try {
    (function () {
      document.querySelectorAll('[data-price-trend-plot]').forEach(function (plot) {
        if (plot.dataset.rcTrendBound) return;
        plot.dataset.rcTrendBound = '1';

        var svg = plot.querySelector('.price-trend-chart__svg');
        var hitSurface = plot.querySelector('.price-trend-chart__hit-surface');
        var crosshair = plot.querySelector('.price-trend-chart__crosshair');
        var tooltip = plot.querySelector('.price-trend-chart__tooltip');
        var tooltipPrice = plot.querySelector('.price-trend-chart__tooltip-price');
        var tooltipDate = plot.querySelector('.price-trend-chart__tooltip-date');
        var points = Array.prototype.slice.call(plot.querySelectorAll('.price-trend-chart__point'));
        if (!svg || !hitSurface || !points.length) return;

        function svgPoint(clientX) {
          var rect = svg.getBoundingClientRect();
          var viewBox = svg.viewBox.baseVal;
          var ratio = (clientX - rect.left) / rect.width;
          return viewBox.x + ratio * viewBox.width;
        }

        function nearestPoint(svgX) {
          var closest = points[0];
          var closestDist = Math.abs(parseFloat(points[0].dataset.x) - svgX);
          for (var i = 1; i < points.length; i++) {
            var dist = Math.abs(parseFloat(points[i].dataset.x) - svgX);
            if (dist < closestDist) {
              closest = points[i];
              closestDist = dist;
            }
          }
          return closest;
        }

        function showAt(point) {
          var x = point.dataset.x;
          crosshair.setAttribute('x1', x);
          crosshair.setAttribute('x2', x);
          crosshair.hidden = false;

          tooltipPrice.textContent = point.dataset.price;
          tooltipDate.textContent = point.dataset.date;

          var rect = svg.getBoundingClientRect();
          var viewBox = svg.viewBox.baseVal;
          var leftPx = ((x - viewBox.x) / viewBox.width) * rect.width;
          tooltip.style.left = leftPx + 'px';
          tooltip.hidden = false;
        }

        function handlePointer(event) {
          var svgX = svgPoint(event.clientX);
          showAt(nearestPoint(svgX));
        }

        hitSurface.addEventListener('pointerdown', handlePointer);
        hitSurface.addEventListener('pointermove', function (event) {
          if (event.pointerType === 'touch') return;
          handlePointer(event);
        });

        document.addEventListener('pointerdown', function (event) {
          if (!plot.contains(event.target)) {
            tooltip.hidden = true;
            crosshair.hidden = true;
          }
        });
      });
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add"] && !Shopify.designMode) return;
  try {
    (function () {
    // One handler for every quick-add button on the page, replacing the old
    // inline onclick. The snippet's javascript block is only emitted once.
    if (window.rcQuickAddReady) return;
    window.rcQuickAddReady = true;

    var TOAST_MS = 3000;
    var CHECK_MS = 1500;
    var toastTimer = null;

    function visibleTop(el) {
      if (!el) return null;
      var rect = el.getBoundingClientRect();
      var style = getComputedStyle(el);
      if (rect.height === 0 || style.visibility === 'hidden' || style.display === 'none' || Number(style.opacity) === 0) return null;
      return rect.top < window.innerHeight ? rect.top : null;
    }

    // The toast sits above the cookie banner and the sticky add-to-cart bar
    // when either is showing, so it never covers them.
    function toastOffset() {
      var offset = 12;
      ['#shopify-pc__banner', '.sticky-add-to-cart__bar'].forEach(function (selector) {
        var top = visibleTop(document.querySelector(selector));
        if (top !== null) offset = Math.max(offset, window.innerHeight - top + 12);
      });
      return offset;
    }

    function showToast(button) {
      var toast = document.getElementById('rc-toast');
      if (!toast) return;
      var offset = toastOffset();
      toast.style.setProperty('--rc-toast-bottom', offset + 'px');
      toast.classList.add('visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toast.classList.remove('visible');
      }, TOAST_MS);

      // Keep the card being used clear of the toast: scroll it up if needed.
      var safeBottom = window.innerHeight - offset - 48 - 8;
      var overlap = button.getBoundingClientRect().bottom - safeBottom;
      if (overlap > 0) window.scrollBy({ top: overlap, behavior: 'smooth' });
    }

    function reset(button) {
      button.disabled = false;
      button.removeAttribute('data-state');
    }

    function quickAdd(button) {
      var id = Number(button.dataset.variantId);
      if (!id || button.disabled) return;

      // Disable synchronously so a second tap cannot send a second add.
      button.disabled = true;
      button.setAttribute('data-state', 'busy');

      var settle;
      var promise = new Promise(function (resolve) { settle = resolve; });
      var event = Object.assign(new Event('shopify:cart:lines-update', { bubbles: true }), { action: 'add', promise: promise });
      document.dispatchEvent(event);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add failed: ' + response.status);
          return response.json();
        })
        .then(function () {
          return fetch('/cart.js').then(function (response) { return response.json(); });
        })
        .then(function (cart) {
          settle({ cart: { totalQuantity: cart.item_count }, detail: { didError: false } });
          button.setAttribute('data-state', 'added');
          showToast(button);
          setTimeout(function () { reset(button); }, CHECK_MS);
        })
        .catch(function (error) {
          settle({ detail: { didError: true } });
          reset(button);
          console.error('Quick add failed:', error);
        });
    }

    document.addEventListener('click', function (event) {
      var button = event.target instanceof Element ? event.target.closest('.rc-quick-add') : null;
      if (!button) return;
      // The button can sit inside a card link, so stop the card from navigating.
      event.preventDefault();
      event.stopPropagation();
      quickAdd(button);
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["spin-viewer"] && !Shopify.designMode) return;
  try {
    window.RCSpinViewer = window.RCSpinViewer || {
    bind: function (viewerEl, canvasEl, frameUrls) {
      if (viewerEl.dataset.rcSpinBound) return;
      viewerEl.dataset.rcSpinBound = '1';

      // Higher = less sensitive drag (more px of movement per frame step).
      var PIXELS_PER_FRAME = 8;

      var images = new Array(frameUrls.length);
      var loadedCount = 0;
      var currentIndex = 0;
      var ctx = canvasEl.getContext('2d');

      function frameCount() { return frameUrls.length; }

      function draw() {
        var img = images[currentIndex];
        if (!img || !img.complete || !img.naturalWidth) return;
        var cw = canvasEl.width, ch = canvasEl.height;
        if (!cw || !ch) return;
        ctx.clearRect(0, 0, cw, ch);
        // Cover-fit: crop the frame to fill the canvas without distortion.
        var canvasRatio = cw / ch;
        var imgRatio = img.naturalWidth / img.naturalHeight;
        var sx, sy, sw, sh;
        if (imgRatio > canvasRatio) {
          sh = img.naturalHeight;
          sw = sh * canvasRatio;
          sx = (img.naturalWidth - sw) / 2;
          sy = 0;
        } else {
          sw = img.naturalWidth;
          sh = sw / canvasRatio;
          sx = 0;
          sy = (img.naturalHeight - sh) / 2;
        }
        ctx.drawImage(img, sx, sy, sw, sh, 0, 0, cw, ch);
      }

      function resizeCanvas() {
        var rect = viewerEl.getBoundingClientRect();
        var dpr = window.devicePixelRatio || 1;
        canvasEl.width = Math.max(1, Math.round(rect.width * dpr));
        canvasEl.height = Math.max(1, Math.round(rect.height * dpr));
        draw();
      }

      frameUrls.forEach(function (url, i) {
        var img = new Image();
        img.onload = function () {
          loadedCount++;
          if (i === currentIndex) draw();
          if (loadedCount === frameUrls.length) viewerEl.classList.add('rc-spin-viewer--ready');
        };
        img.src = url;
        images[i] = img;
      });

      var dragging = false;
      var startX = 0;
      var startIndex = 0;

      function setIndexFromDelta(deltaX) {
        var steps = Math.round(deltaX / PIXELS_PER_FRAME);
        var idx = (startIndex - steps) % frameCount();
        if (idx < 0) idx += frameCount();
        if (idx !== currentIndex) {
          currentIndex = idx;
          draw();
        }
      }

      viewerEl.addEventListener('pointerdown', function (e) {
        dragging = true;
        startX = e.clientX;
        startIndex = currentIndex;
        viewerEl.setPointerCapture(e.pointerId);
        viewerEl.classList.add('rc-spin-viewer--dragging');
      });
      viewerEl.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        setIndexFromDelta(e.clientX - startX);
      });
      function endDrag() {
        dragging = false;
        viewerEl.classList.remove('rc-spin-viewer--dragging');
      }
      viewerEl.addEventListener('pointerup', endDrag);
      viewerEl.addEventListener('pointercancel', endDrag);

      window.addEventListener('resize', resizeCanvas);
      resizeCanvas();
    },
  };
  } catch(e) { console.error(e); }
})();

})();
